import React, { useState, useEffect } from "react";
import Button from "../../Button/Button";
import Select from "../../Select/Select";

import "./TeaserPayment.scss";
import ReasonListModal from "../../ReasonListModal/ReasonListModal";

import {
  payoutStatus,
  gradeStatus,
  gradeStatusOptions
} from "../../../constants";

function getButtonText(status) {
  return {
    [payoutStatus.success]: "OK",
    [payoutStatus.fail]: "Отказ",
    [payoutStatus.edit]: "Ошибка",
    [payoutStatus.penalty]: "Штраф"
  }[status];
}

function getButtonColor(status) {
  return {
    [payoutStatus.success]: "green",
    [payoutStatus.fail]: "black",
    [payoutStatus.edit]: "purple",
    [payoutStatus.penalty]: "red"
  }[status];
}

const statusList = [
  payoutStatus.success,
  payoutStatus.fail,
  payoutStatus.penalty,
  payoutStatus.edit
];

const TeaserPayment = ({
  teaser,
  onSelect,
  discardReasons,
  errorReasons,
  penaltyReasons,
  onGradeChange
}) => {
  const [state, setState] = useState(teaser.payout_status);

  useEffect(() => {
    setState(teaser.payout_status);
  }, [teaser.payout_status]);

  const onCancel = () => {
    onSelect(payoutStatus.wait, []);
  };

  const onOk = () => {
    onSelect(payoutStatus.success, []);
  };

  const onFail = e => {
    if (!e.value) {
      return;
    }
    setState(payoutStatus.wait);
    onSelect(payoutStatus.fail, [{ message: e.label }]);
  };

  const onError = e => {
    setState(payoutStatus.wait);
    onSelect(payoutStatus.edit, e.selectedItems);
  };

  const onPenalty = e => {
    setState(payoutStatus.wait);
    onSelect(payoutStatus.penalty, e.selectedItems);
  };

  const onGradeSelect = selected => {
    onGradeChange(selected.value);
  };

  // статус проставлен можно отменить
  if (statusList.includes(state)) {
    return (
      <div className="teaser__payment">
        <Button color="white">{getButtonText(state)}</Button>
        <Button color="blue" onClick={onCancel}>
          Отмена
        </Button>
        <Select
          className="grade-status-select"
          options={gradeStatusOptions}
          value={teaser.grade_status}
          onSelect={onGradeSelect}
        />
      </div>
    );
  }

  // ожидает оплаты, можно отобразить кнопки
  if (state == payoutStatus.wait) {
    return (
      <div className="teaser__payment">
        <Button color="green" onClick={onOk}>
          {getButtonText(payoutStatus.success)}
        </Button>
        {/*<Button color="black" onClick={() => setState("failSelect")}>
                    {getButtonText(payoutStatus.fail)}
                </Button>*/}

        <Button color="purple" onClick={() => setState("errorSelect")}>
          {getButtonText(payoutStatus.edit)}
        </Button>

        <Button color="red" onClick={() => setState("penaltySelect")}>
          {getButtonText(payoutStatus.penalty)}
        </Button>

        <Select
          className="grade-status-select"
          options={gradeStatusOptions}
          value={teaser.grade_status}
          onSelect={onGradeSelect}
        />
      </div>
    );
  }

  if (state == "failSelect") {
    return (
      <div className="teaser__payment penalty">
        <Select
          options={discardReasons}
          value={""}
          placeholder="Выбор причины"
          onSelect={onFail}
        />
        <Button
          color="blue"
          onClick={() => {
            setState(payoutStatus.wait);
          }}
        >
          Отмена
        </Button>
      </div>
    );
  }

  if (state == "errorSelect") {
    return (
      <ReasonListModal
        onCancel={() => setState(payoutStatus.wait)}
        onConfirm={onError}
        items={errorReasons}
      />
    );
  }

  if (state == "penaltySelect") {
    return (
      <ReasonListModal
        onCancel={() => setState(payoutStatus.wait)}
        onConfirm={onPenalty}
        items={penaltyReasons}
        showPrice
      />
    );
  }

  return null;
};

TeaserPayment.defaultPros = {
  discardReasons: [],
  errorReasons: [],
  penaltyReasons: []
};

export default TeaserPayment;
